
export default {
  auth: false,
  layout: 'login',
  head () {
    return {
      titleTemplate: this.$t('privacy_policy') + ' - %s',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('meta.polityka_prywatnosci')
        }
      ],
    }
  },
}
